import { render, staticRenderFns } from "./DigitalTimeCard.vue?vue&type=template&id=37b76a10&scoped=true&"
import script from "./DigitalTimeCard.vue?vue&type=script&lang=js&"
export * from "./DigitalTimeCard.vue?vue&type=script&lang=js&"
import style0 from "./DigitalTimeCard.vue?vue&type=style&index=0&id=37b76a10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b76a10",
  null
  
)

export default component.exports